// import React, { useEffect, useState } from 'react';
// import Sidebar from 'pages/sideBar/SideBar';
// import { CiSearch } from "react-icons/ci";
// import Invoice from 'components/invoice/Invoice';
// import Skeleton from '@mui/material/Skeleton';
// import '../app.css';
// import './invoice.css';
// import imgReviews from '../../../../assets/images/invoice.png';
// import axios from 'axios';
// import PopupInvoice from 'pages/clientDashbaord/popupinovie/popupInvoice';
// import NoDataImage from '../../../../assets/images/nodataImg.png'
// import { useNavigate } from 'react-router-dom';
// import { Button } from 'components';
// function InvoicePage() {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedInvoice, setSelectedInvoice] = useState(null);
//   const [displayCount, setDisplayCount] = useState(15);
//   const navigate = useNavigate()
//   const fetchData = async () => {
//     const token = localStorage.getItem('accessToken'); // Retrieve token from local storage
//     const apiUrl = 'https://backend.washta.com/api/seller/order'; // Replace with your API endpoint

//     try {
//       const response = await axios.get(apiUrl, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       console.log("invoice", response.data.data);
//       setData(response.data.data);
//     } catch (err) {
//       if (err.response && err.response.status === 401) {
//         localStorage.clear();
//         navigate('/');
//       } 
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     fetchData();
//   }, []);
//   const handleDetailsClick = (invoice) => {
//     setSelectedInvoice(invoice);
//     setModalOpen(true);
//   };

//   return (
//     <div className='mainDiv-all-sideBar'>
//       <div className='div-sidebar'>
//         <Sidebar />
//       </div>
//       <div className='div-Dashbaord'>
//         <div className='main-inove-div-search'>
//           <h1 className='h1-all-heading'>Invoices</h1>
//           <div className='icon-postion-div-inoice'>
//             <input placeholder='search invoice' className='invoice-search-icon-div' />
//             <CiSearch style={{ position: 'absolute', right: 10, top: '22%', fontSize: 18 }} />
//           </div>
//         </div>
//         <div className="dashboard">
//           <div className='styles-div' style={{ width: '100%' }}>
//             <div className='invoice-border'>
//               <div className='chart-colm-div-heading'>
//                 <img src={imgReviews} style={{ width: '1.4em', objectFit: 'contain' }} />
//                 <h2 className='main-heading2'>History</h2>
//               </div>
//               {loading ? (
//                 Array.from(new Array(6)).map((_, index) => (
//                   <div key={index} style={{background:'#747eef9c', padding: '10px 20px', display: 'flex', alignItems: 'center', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '10px' }}>
//                     <Skeleton variant="rectangular" width={48} height={48} style={{ marginRight: '10px', borderRadius: '8px',background:'#747eef9c'}} />
//                     <div style={{ flexGrow: 1 }}>
//                       <Skeleton variant="text" width="50%" height={30} style={{ marginBottom: '5px',background:'#f1f2fd' }} />
//                       <Skeleton style={{background:'#f1f2fd'}} variant="text" width="30%" height={20} />
//                     </div>
//                     <Skeleton tyle={{background:'#f1f2fd'}} variant="text" width="10%" height={50} />
//                   </div>
//                 ))
//                 ) : data?.length === 0 ? (
//                   <div style={{width:'100%',justifyContent:'center',display:'flex'}}>
//                   <img src={NoDataImage} alt="No Data" style={{ maxWidth: '50%', maxHeight: '50%',objectFit:'contain' }} />
//                 </div>
//                 ) :(
//                   data?.filter(item => item.billingStatus !== "non-paid").slice(0, displayCount).map((item) => (
//                     <div key={item.id} style={{ paddingBottom: 15 }}>
//                       <Invoice buttonClick={() => handleDetailsClick(item)} date={item?.date} textInvoice={item?.customerId?._id} btnPurple='Delete' btnTranspraent='Details' />
//                     </div>
//                   ))
//                 )}
//               {displayCount < data.length && (
//                 // <button
//                 //   onClick={() => setDisplayCount(displayCount + 20)} // Show 20 more invoices
//                 //   className="view-more-button"
//                 // >
//                 //   View More
//                 // </button>
//                 <div className='flex justify-center'>

//                 <Button onClick={() => setDisplayCount(displayCount + 20)} className='text-[10px] w-[20%] h-[10%] mt-3 '>
//                   View More
//                 </Button>
//                 </div>
//               )}
//               <PopupInvoice isOpen={modalOpen} onClose={() => setModalOpen(false)} data={selectedInvoice} />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default InvoicePage;
import React, { useEffect, useState } from 'react';
import Sidebar from 'pages/sideBar/SideBar';
import { CiSearch } from "react-icons/ci";
import Invoice from 'components/invoice/Invoice';
import Skeleton from '@mui/material/Skeleton';
import '../app.css';
import './invoice.css';
import imgReviews from '../../../../assets/images/invoice.png';
import axios from 'axios';
import PopupInvoice from 'pages/clientDashbaord/popupinovie/popupInvoice';
import NoDataImage from '../../../../assets/images/nodataImg.png';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components';

function InvoicePage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [displayCount, setDisplayCount] = useState(15);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const fetchData = async () => {
    const token = localStorage.getItem('accessToken');
    const apiUrl = 'https://backend.washta.com/api/seller/order';

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("invoice", response.data.data);
      setData(response.data.data);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        localStorage.clear();
        navigate('/');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  const handleDetailsClick = (invoice) => {
    setSelectedInvoice(invoice);
    setModalOpen(true);
  };

  // Filter by Order ID and billing status
  const filteredData = data
  ?.filter(item => item.billingStatus !== "non-paid")
  ?.filter(item => {
    const lowerSearch = searchTerm.toLowerCase();
    const orderId = item._id?.toLowerCase() || '';
    const customerId = item?._id.toLowerCase() || '';
    const customerName = item.customerId?.fullName?.toLowerCase() || '';
    const date = item.date?.toLowerCase() || '';
    return (
      orderId.includes(lowerSearch) ||
      customerId.includes(lowerSearch) ||
      customerName.includes(lowerSearch) ||
      date.includes(lowerSearch)
    );
  });


  return (
    <div className='mainDiv-all-sideBar'>
      <div className='div-sidebar'>
        <Sidebar />
      </div>
      <div className='div-Dashbaord'>
        <div className='main-inove-div-search'>
          <h1 className='h1-all-heading'>Invoices</h1>
          <div className='icon-postion-div-inoice'>
            <input
              placeholder='search order id'
              className='invoice-search-icon-div'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <CiSearch style={{ position: 'absolute', right: 10, top: '22%', fontSize: 18 }} />
          </div>
        </div>

        <div className="dashboard">
          <div className='styles-div' style={{ width: '100%' }}>
            <div className='invoice-border'>
              <div className='chart-colm-div-heading'>
                <img src={imgReviews} style={{ width: '1.4em', objectFit: 'contain' }} />
                <h2 className='main-heading2'>History</h2>
              </div>

              {loading ? (
                Array.from(new Array(6)).map((_, index) => (
                  <div key={index} style={{ background: '#747eef9c', padding: '10px 20px', display: 'flex', alignItems: 'center', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '10px' }}>
                    <Skeleton variant="rectangular" width={48} height={48} style={{ marginRight: '10px', borderRadius: '8px', background: '#747eef9c' }} />
                    <div style={{ flexGrow: 1 }}>
                      <Skeleton variant="text" width="50%" height={30} style={{ marginBottom: '5px', background: '#f1f2fd' }} />
                      <Skeleton style={{ background: '#f1f2fd' }} variant="text" width="30%" height={20} />
                    </div>
                    <Skeleton style={{ background: '#f1f2fd' }} variant="text" width="10%" height={50} />
                  </div>
                ))
              ) : filteredData.length === 0 ? (
                <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                  <img src={NoDataImage} alt="No Data" style={{ maxWidth: '50%', maxHeight: '50%', objectFit: 'contain' }} />
                </div>
              ) : (
                filteredData.slice(0, displayCount).map((item) => (
                  <div key={item.id} style={{ paddingBottom: 15 }}>
                    <Invoice
                      buttonClick={() => handleDetailsClick(item)}
                      date={item?.date}
                      textInvoice={item?._id}
                      btnPurple='Delete'
                      btnTranspraent='Details'
                    />
                  </div>
                ))
              )}

              {displayCount < filteredData.length && (
                <div className='flex justify-center'>
                  <Button onClick={() => setDisplayCount(displayCount + 20)} className='text-[10px] w-[20%] h-[10%] mt-3'>
                    View More
                  </Button>
                </div>
              )}

              <PopupInvoice isOpen={modalOpen} onClose={() => setModalOpen(false)} data={selectedInvoice} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InvoicePage;
